/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { arrayToQueryString } from '../../utils';

const CustomOption = props => {
  return (
    <components.Option {...props}>
      <div className="pl-2">
        {props.isMulti && (
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
            style={{ marginRight: 10 }}
          />
        )}
        {props.data.label}
      </div>
    </components.Option>
  );
};

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#d3d3d3' : provided.backgroundColor,
    color: state.isSelected ? '#a9a9a9' : provided.color,
    cursor: state.isSelected ? 'not-allowed' : 'pointer'
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? '#f5f5f5' : base.backgroundColor,
    color: state.isDisabled ? '#aaa' : base.color,
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    opacity: state.isDisabled ? 0.6 : 1 // daha soluk görünüm
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.isDisabled ? '#aaa' : '#000'
  }),
  menu: provided => ({
    ...provided,
    zIndex: 9999
  })
};

const Dropdown = ({
  isClearable = true,
  isSearchable = true,
  isDisabled,
  isLoading,
  isRtl,
  isMulti = false,
  onChange,
  selectedValue,
  options,
  label,
  hideUrlParams,
  widthClassName = 'min-w-40'
}) => {
  const optionsWithAll = isMulti
    ? [{ value: '*', label: 'Select All' }, ...options]
    : options;

  const selectedValueTemp = isMulti ? [] : '';
  const [selectedOptions, setSelectedOptions] = useState(
    selectedValue || selectedValueTemp
  );

  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };

  const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center'
  };

  const formatGroupLabel = data => (
    <div className="text-red" style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );

  const handleChange = selected => {
    if (!selected) {
      setSelectedOptions(isMulti ? [] : '');
      onChange(isMulti ? [] : '');
      return;
    }

    if (isMulti) {
      const isAllSelected = selected.some(option => option.value === '*');

      if (isAllSelected) {
        if (selectedOptions.length === options.length) {
          setSelectedOptions([]);
          onChange([]);
        } else {
          setSelectedOptions(options);
          onChange(options);
        }
        if (label && !hideUrlParams) {
          arrayToQueryString(options, label);
        }
        return;
      }

      setSelectedOptions(selected);
      onChange(selected);
      if (label && !hideUrlParams) {
        arrayToQueryString(selected, label);
      }
    } else {
      setSelectedOptions(selected);
      onChange(selected);
      if (label && !hideUrlParams) {
        arrayToQueryString(selected, label);
      }
    }
  };

  useEffect(() => {
    if (selectedValue) {
      setSelectedOptions(selectedValue);
    }
  }, [selectedValue]);

  return (
    <div className="select-container">
      {label && (
        <label className="select-label capitalize dark:border-strokedark dark:bg-meta-4 dark:text-white dark:focus:border-primary">
          {label === 'authors' ? 'developers' : label}
        </label>
      )}
      <Select
        classNamePrefix="my-react-select"
        className={'my-react-select-container ' + widthClassName}
        defaultValue={selectedOptions?.[0]}
        value={selectedOptions}
        options={optionsWithAll}
        onChange={handleChange}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        formatGroupLabel={formatGroupLabel}
        filterOption={
          label === 'repos'
            ? (candidate, input) =>
                [
                  candidate.data.label,
                  candidate.data.name,
                  candidate.data.fullName
                ].some(value =>
                  String(value || '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                )
            : undefined
        }
        styles={customStyles}
        components={{ Option: CustomOption }}
      />
    </div>
  );
};

export default Dropdown;
